export enum ApplicationSourceType {
  GENERIC_LINK = 'genericLink',
  PERSONALIZED_QUOTE = 'personalizedQuote',
  START_AGENT_ASSISTED = 'startAAA',
  SEND_AGENT_ASSISTED = 'sendAAA',
  REAPPLY = 'reapply',
  DUPLICATE = 'duplicate',
  ADVISOR_EDIT = 'advisorEdit',
  MULTIPLE_POLICIES = 'multiplePolicies',
  ADVISOR_DRIVEN_ANNUITY_APPLICATION = 'advisorDrivenAnnuityApplication',
}
